module.exports = { baseURL: "https://api.virtuphone.com" }
